<div id="close">
  <div class="modal-toolbar-system-name">
    <img class="logo-size" src="/assets/img/logos/logo-sap-interna.png">
  </div>
  @if (!importing) {
    <a (click)="close()">
      <mat-icon class="icon-pattern">close</mat-icon>
    </a>
  }
</div>

@if (!importing) {
  <h4 mat-dialog-title class="modal-toolbar-title primary">IMPORTAR ESCOLAS</h4>
}
@if (importing) {
  <h4 mat-dialog-title class="modal-toolbar-title primary">IMPORTANDO ESCOLAS</h4>
}

@if (!importing) {
  <mat-dialog-content class="content-dialog">
    <form [formGroup]="importSchoolsForm">
      <div>
        <div id="text" class="primary-text">
          <p>Selecione o arquivo para importação e clique em IMPORTAR.</p>
          <p>Em caso de dúvida <a style="text-decoration: underline;  color: blue; "
          href="{{url}}/modelo_importacao_escolas.csv">baixe aqui</a> o modelo do arquivo de importação.</p>
        </div>
        <label for="fileInput">
          @if (!importSchoolsForm.get('import_file').value) {
            <input type="file" id="fileInput" (change)="getMedia($event)" accept=".csv">
          }
          <div ntmDnd id="fileArea" (ntmDnd)="!importSchoolsForm.get('import_file').value ? getMedia($event) : ''" accept=".csv">
            <div class="flex justify-center align-center">
              <p>{{ importSchoolsForm.get('import_file').value ? importSchoolsForm.get('import_file')?.value?.name ||
                importSchoolsForm.get('import_file')?.value : 'Arraste e solte o arquivo de documento
              aqui ou clique para selecionar o documento em seu computador.*' }}</p>
              @if (importSchoolsForm.get('import_file').value) {
                <mat-icon class="pointer" (click)="deleteFile()">delete</mat-icon>
              }
            </div>
          </div>
        </label>
        <p class="extension-import">Arquivos apenas no formato CSV.</p>
        @if (importErrors) {
          <div class="div-error">
            <p>{{schoolsImported}} escola(s) importada(s) e {{importErrors.length}} erro(s) encontrado(s):</p>
            <ul>
              @for (importError of importErrors; track importError) {
                <li>
                  Linha: {{importError.row}}
                  <ul>
                    @for (field of importError.fields; track field) {
                      <li>O valor da coluna {{field}} é inválido.</li>
                    }
                  </ul>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </form>
  </mat-dialog-content>
}

@if (!importing) {
  <div class="modal-footer">
    <button id="modalApplyBtn" type="submit" mat-raised-button color="accent" [disabled]="!importSchoolsForm.valid" (click)="importSchools()"> Importar </button>
  </div>
}

@if (importing) {
  <div>
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
}

